import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import { useCallback, useMemo } from 'react';
import Raven from 'raven-js';
import { useRemoveFromWatchLater } from '../../watchLater/watchLaterQueries';
import { useAddToWatchLater } from '../../watchLater/watchLaterQueries';
import { useWatchLater } from '../../watchLater/watchLaterQueries';
import UsageTracker from '../../../utils/UsageTracker';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { useCatalogCardModels } from 'academy-common-lib/features/catalog/hooks/useCatalogCardModels';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AddedOrRemovedToWatchLaterNotification = ({
  isItemAddedToWatchLater,
  item
}) => {
  var _catalogCardModels$;
  // needs to retrieve the card model for the name
  // will be removed after migration
  const {
    catalogCardModels
  } = useCatalogCardModels({
    items: [item]
  });
  const itemName = (catalogCardModels === null || catalogCardModels === void 0 || (_catalogCardModels$ = catalogCardModels[0]) === null || _catalogCardModels$ === void 0 ? void 0 : _catalogCardModels$.name) || '';
  if (!itemName) return null;
  if (isItemAddedToWatchLater) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.savedItems.tooltips.removedFromWatchLater",
      options: {
        title: itemName
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.savedItems.tooltips.savedToWatchLater",
    options: {
      title: itemName
    }
  });
};
export const useToggleAddToWatchLater = ({
  id: assetId,
  type: containerType
}) => {
  const {
    data: allWatchLaterItems,
    loading: allWatchLaterItemsLoading
  } = useWatchLater({
    pageLength: 10000,
    // gets full saved items list
    contentTypes: [],
    offset: {
      cursor: 0
    },
    durationFilters: []
  });
  const [addToWatchLater, {
    loading: addToWatchLaterLoading
  }] = useAddToWatchLater({
    assetId,
    containerType: containerType
  });
  const [removeFromWatchLater, {
    loading: removeFromWatchLaterLoading
  }] = useRemoveFromWatchLater({
    assetId,
    containerType: containerType
  });
  const isItemAddedToWatchLater = useMemo(() => allWatchLaterItems === null || allWatchLaterItems === void 0 ? void 0 : allWatchLaterItems.results.some(({
    id,
    type
  }) => id === assetId && type === containerType), [allWatchLaterItems, assetId, containerType]);
  const toggleIsItemAddedToWatchLater = isItemAddedToWatchLater ? removeFromWatchLater : addToWatchLater;
  return {
    isItemAddedToWatchLater,
    toggleIsItemAddedToWatchLater,
    isToggleAddToWatchLaterLoading: addToWatchLaterLoading || removeFromWatchLaterLoading || allWatchLaterItemsLoading
  };
};
const CardMenuWatchLaterOption = ({
  item,
  render = content => {
    return /*#__PURE__*/_jsx(SideNavItem, {
      role: "navigation-item",
      title: content
    });
  },
  onClick
}) => {
  const {
    isItemAddedToWatchLater,
    toggleIsItemAddedToWatchLater,
    isToggleAddToWatchLaterLoading
  } = useToggleAddToWatchLater(item);
  const handleOnClick = useCallback(() => {
    onClick === null || onClick === void 0 || onClick();
    if (isToggleAddToWatchLaterLoading) return;
    toggleIsItemAddedToWatchLater().then(() => {
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(AddedOrRemovedToWatchLaterNotification, {
          isItemAddedToWatchLater: !!isItemAddedToWatchLater,
          item: item
        }),
        type: 'success'
      });
      UsageTracker.track('interaction', {
        action: isItemAddedToWatchLater ? 'favorite-removed' : 'favorite-added',
        contentId: item.id,
        contentType: item.type
      });
    }).catch(Raven.captureException);
  }, [isItemAddedToWatchLater, isToggleAddToWatchLaterLoading, item, onClick, toggleIsItemAddedToWatchLater]);
  return /*#__PURE__*/_jsx("div", {
    "aria-disabled": isToggleAddToWatchLaterLoading,
    "data-test-id": "watch-later-button",
    onClick: handleOnClick,
    children: render( /*#__PURE__*/_jsxs(TFlex, {
      align: "center",
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsx("span", {
        style: {
          flex: isToggleAddToWatchLaterLoading ? undefined : 1,
          opacity: isToggleAddToWatchLaterLoading ? 0.3 : 1
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: isItemAddedToWatchLater ? 'learningCenter.cardMenu.removeFromWatchLater' : 'learningCenter.cardMenu.addToWatchLater'
        })
      }), isToggleAddToWatchLaterLoading && /*#__PURE__*/_jsx(LoadingSpinner, {
        margin: "0",
        size: "extra-small"
      })]
    }))
  });
};
export default CardMenuWatchLaterOption;